import { CustomField } from '@bandido/shared/types/client';
import React, { createContext, useContext, useEffect, useState } from 'react';

interface DynamicFieldsContextValue {
  fields: CustomField[],
  updateFields: (newFields: CustomField[]) => void;
}

const DynamicFieldsContext = createContext<DynamicFieldsContextValue | undefined>(undefined);

interface DynamicFieldsProviderProps {
  children: JSX.Element;
  fields: CustomField[];
  onUpdateFields?: (newFields: CustomField[]) => void;
}

export function DynamicFieldsProvider({ children, fields, onUpdateFields }: DynamicFieldsProviderProps) {
  const [internalFields, setInternalFields] = useState<CustomField[]>([]);

  useEffect(() => {
    setInternalFields(fields);
  }, [fields]);

  return React.createElement(
    DynamicFieldsContext.Provider,
    {
      value: {
        fields: internalFields,
        updateFields: (newFields: CustomField[]) => {
          setInternalFields(newFields);
          onUpdateFields?.(newFields);
        }
      },
    },
    children,
  );
}

export const useDynamicFields = (): DynamicFieldsContextValue => {
  const context = useContext(DynamicFieldsContext);
  if (!context) {
    throw new Error('DynamicFieldsContext must be used within a DynamicFieldsProvider');
  }
  return context;
};
